import { MODALS } from 'common/domain/constants';
import { LOANS } from 'loans.module/common/domain/constants.loans';
class LoansSignUpFormController {
  constructor(EventEmitter, LoansNeedALoanService) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.loansNeedALoanService = LoansNeedALoanService;
  }

  $onInit() {
    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  get modal() {
    const $modal = $(MODALS.LOANS_CONFIRMATION_SIGN_UP);
    return $modal;
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.CONTRACT',
        disabled: true,
      },
      {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL',
      },
    ];
  }

  isDisabledCreateLoan() {
    return this.finished || !this.acceptLegalConditions;
  }

  onAcceptLegalConditions($event) {
    this.acceptLegalConditions = $event.accept;

    if (this.isMobileApp) {
      this.floatingActionButtons[0].disabled = this.isDisabledCreateLoan();
    }
  }

  cancelCreateLoan() {
    this.onCancelCreateLoan();
  }

  createLoan() {
    this.onCreateLoan(this.EventEmitter({ loan: this.getLoan() }));
    this.finished = true;

    if (this.isMobileApp) {
      this.loansNeedALoanService.clearAllDataSimulation();
    }
  }

  getLoan() {
    return {
      loanId: this.loan.idHr,
      loanPurposeId: this.backSimulation.loanPurposeId,
      amount: this.sanitizeNumber(this.backSimulation.amount),
      deadline: this.sanitizeNumber(this.backSimulation.deadline),
      monthlyAmount: this.sanitizeNumber(this.backSimulation.monthlyAmount),
      interestRate: this.sanitizeNumber(this.backSimulation.interestRates),
      annualPercentageRate: this.sanitizeNumber(this.backSimulation.tae),
      wantInsurance: this.backSimulation.wantInsurance,
      typeFixedVariable: this.backSimulation.typeFixedVariable || '0',
      acquisitionCost: this.sanitizeNumber(
        this.simulation.amountSimulation.acquisitionCost
      ),
      salePrice: this.sanitizeNumber(
        this.simulation.amountSimulation.salePrice
      ),
      loanSituation: this.backSimulation.loanSituation,
    };
  }

  sanitizeNumber(n) {
    return parseFloat(n, 10) || 0;
  }

  isDisabledOnFinished() {
    return this.finished;
  }
  isSocialOrAgreementHousingLoan() {
    return (
      this.backSimulation.loanId === LOANS.ID_HR.SOCIAL_HOUSING_LOAN ||
      this.backSimulation.loanId === LOANS.ID_HR.AGREEMENT_HOUSING_LOAN
    );
  }
  
  openModal() {
    this.isSocialOrAgreementHousingLoan() ? this.modal.modal('show') : this.createLoan() ;
  }
}

export default LoansSignUpFormController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpForm/loansSignUpForm.controller.js